/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ComponentFactoryResolver, ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';
import { ICellEditor, ICellEditorComp, ICellEditorParams } from 'ag-grid-community';
import { isFunction } from 'lodash';
import { GridComponentFactory } from './grid-component-factory';
import { GridCellEditorComponent } from './grid-component.interfaces';

@Injectable()
export class GridCellEditorFactory implements GridComponentFactory<Type<GridCellEditorComponent>, Type<ICellEditor>> {
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {

  }

  createComponent(componentType: Type<GridCellEditorComponent>,
                  viewContainerRef: ViewContainerRef): Type<ICellEditorComp> {
    const that = this;

    class ComponentCellEditor implements ICellEditor {
      private componentRef: ComponentRef<GridCellEditorComponent>;
      private componentInstance: GridCellEditorComponent;

      init(params: ICellEditorParams): void {
        const factory = that.componentFactoryResolver.resolveComponentFactory(componentType);
        this.componentRef = viewContainerRef.createComponent(factory);
        this.componentInstance = this.componentRef.instance;
        this.componentInstance.agInit(params);
        this.componentRef.changeDetectorRef.detectChanges();
      }

      afterGuiAttached(): void {
        if (isFunction(this.componentInstance.afterGuiAttached)) {
          this.componentInstance.afterGuiAttached();
        }
      }

      destroy(): void {
        this.componentRef.destroy();
      }

      getValue(): any {
        return this.componentRef.instance.getValue();
      }

      getGui(): HTMLElement {
        return this.componentRef.location.nativeElement;
      }

      isPopup(): boolean {
        return isFunction(this.componentInstance.isPopup) ? this.componentInstance.isPopup() : false;
      }

      isCancelBeforeStart(): boolean {
        return isFunction(this.componentInstance.isCancelBeforeStart)
          ? this.componentInstance.isCancelBeforeStart() : false;
      }

      isCancelAfterEnd(): boolean {
        return isFunction(this.componentInstance.isCancelAfterEnd) ? this.componentInstance.isCancelAfterEnd() : false;
      }

      focusIn(): void {
        if (isFunction(this.componentInstance.focusIn)) {
          this.componentInstance.focusIn();
        }
      }

      focusOut(): void {
        if (isFunction(this.componentInstance.focusOut)) {
          this.componentInstance.focusOut();
        }
      }
    }

    return ComponentCellEditor;
  }
}
